import { attr } from '@ember-data/model';
import ShModel from './sh-model';

class Heartbeat extends ShModel {
  @attr account;
  @attr activityFeed;
  @attr admin;
  @attr global;
  @attr messages;
  @attr notifications;
  @attr web;
}

export default Heartbeat;
